import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import './__mocks__';
import { Payment, PaymentChartFilters } from './types/types';

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/payments`,
  }),
  tagTypes: ['Payments'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getPayments: builder.query<Payment[], PaymentChartFilters>({
      query: params => ({
        url: ``,
        params,
      }),
      providesTags: ['Payments'],
    }),
  }),
});

export const { useGetPaymentsQuery } = paymentApi;
